export enum PoiConfigurationEnumType {
  SWITCH = 'SWITCH',
  AGENT = 'AGENT',
}

export enum PoiTypeEnumType {
  ATTRACTION = 'ATTRACTION',
  HOTEL = 'HOTEL',
}
